import { computed, Injectable, signal } from '@angular/core';
import { debounceTime, distinctUntilChanged, fromEvent, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WindowService {

  private _width = signal(this.windowRef.innerWidth);
  private _height = signal(this.windowRef.innerHeight);

  private _width$ = fromEvent(this.windowRef, 'resize').pipe(
    map(() => this.windowRef.innerWidth),
    distinctUntilChanged(),
    debounceTime(10)
  );
  private _height$ = fromEvent(this.windowRef, 'resize').pipe(
    map(() => this.windowRef.innerHeight),
    distinctUntilChanged(),
    debounceTime(10)
  );

  readonly width = computed(() => this._width());
  readonly height = computed(() => this._height());

  get windowRef() {
    return window;
  }

  constructor() {
    this._width$.subscribe((width) => this._width.set(width));
    this._height$.subscribe((height) => this._height.set(height));
  }

}
